import Swiper from 'swiper';
import Navigation from 'swiper/modules/navigation.mjs';

document.addEventListener('DOMContentLoaded', function ()  {
  document.querySelectorAll('.swiper-reviews').forEach(
    /**
     * @param {HTMLBaseElement} swiper
     */
    (swiper) => {
      new Swiper(swiper, {
        modules: [ Navigation ],
        speed: 400,
        spaceBetween: 24,
        slidesPerView: 1,
        cssWidthAndHeight: true,
        visibilityFullFit: true,
        autoResize: false,
        cssMode: false,
        breakpoints: {
          640: {
            slidesPerView: 2
          },
          940: {
            slidesPerView: 3
          },
          1150: {
            slidesPerView: 4
          },
        },
        navigation: {
          enabled: true,
          nextEl: swiper.closest('.reviews-container').querySelector('.swiper-button-next'),
          prevEl: swiper.closest('.reviews-container').querySelector('.swiper-button-prev'),
        },
      });
    });
});
